










































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import { CrudList, DataTable, NoDataFound } from '../../components';

import { CrudListMixin } from '../../mixins/crud-list.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

export default {
  name: 'blacklist-list',
  components: {
    CrudList,
    DataTable,
    NoDataFound
  },
  mixins: [CrudListMixin],
  data: function () {
    const messages = this.$epb.messages.tools.blacklist;
    return {
      dataType: ActionTypeEnum.BLACKLIST,
      routes: {
        create: ROUTER_CONSTS.routes.blacklist.create,
        update: ROUTER_CONSTS.routes.blacklist.update
      },
      columns: [
        {
          id: 'lang',
          text: messages.fields.lang.label,
          sortable: true
        }, {
          id: 'terms',
          text: messages.fields.terms.label,
          width: '200%'
        }, {
          id: 'meta.updateDate',
          text: messages.fields.updateDate.label,
          sortable: true
        }, {
          id: 'enabled',
          text: messages.fields.enabled.label,
          sortable: true
        }
      ],
      messages: messages
    };
  }
};

